/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardFooter,
  MDBCol
} from 'mdb-react-ui-kit';
import EmailIcon from '@mui/icons-material/Email';
import TwitterIcon from '@mui/icons-material/Twitter';
import tonyimage from "../../images/teamimages/Tony.JPG";
import karhauimage from "../../images/teamimages/John.jpg";
import marceloimage from "../../images/teamimages/Marcelo.jpg";
import ankhmaaimage from "../../images/teamimages/Ankhmaa.jpg";
import './Team.css';
import '../../App.css';

const Team = () => {
  return (
    <div className="container">
    <div id="meetteam" className='knowtheteam' style={{paddingTop:'1rem', marginBottom:'3rem'}}>
      <div className='know_team reveal'>
        <h1>Meet the Team</h1>
        <h3>The SUNRISE Coordinating Centre team is based at Early Start, University of Wollongong, Australia.</h3>
        <div className='reveal' id="team">
          {/* <MDBRow className='row-cols-1 row-cols-md-3 g-4'> */}
          <MDBCol>
            <MDBCard >
              <MDBCardImage style={{ objectFit: 'cover' }}
                src={tonyimage}
                alt='Dist. Prof Anthony Okely'
                position='top'
              />
              <MDBCardBody><br />
                <MDBCardTitle style={{ fontSize: '16px' }}>Dist. Prof Anthony Okely</MDBCardTitle><br />
                <MDBCardText style={{ fontSize: '13px' }}>
                  Principal Investigator
                </MDBCardText>
              </MDBCardBody>
              <MDBCardFooter id='connect'>
                <a href="mailto:tokely@uow.edu.au" target="_blank" rel="noreferrer">
                  <EmailIcon style={{ color: 'darkblue' }} />
                </a>
                <a href="https://twitter.com/tonyokely" target="_blank" rel="noreferrer">
                  <TwitterIcon style={{ color: 'rgb(49, 168, 232)' }} />
                </a>
              </MDBCardFooter>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className='h-100'>
              <MDBCardImage style={{ objectFit: 'cover' }}
                src={marceloimage}
                alt='Marcelo  Toledo-Vargas'
                position='top'
              />
              <MDBCardBody><br />
                <MDBCardTitle style={{ fontSize: '16px' }}>Marcelo Toledo-Vargas</MDBCardTitle><br />
                <MDBCardText style={{ fontSize: '13px' }}>
                  Research Officer
                </MDBCardText>
                <MDBCardText style={{ fontSize: '13px' }}>
                  PhD student
                </MDBCardText>
              </MDBCardBody>
              <MDBCardFooter id='connect'>
                <a href="https://twitter.com/marcelotoledov" target="_blank" rel="noreferrer">
                  <TwitterIcon style={{ color: 'rgb(49, 168, 232)' }} />
                </a>
              </MDBCardFooter>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className='h-100'>
              <MDBCardImage style={{ objectFit: 'cover' }}
                src={ankhmaaimage}
                alt='Ankhmaa Byambaa'
                position='top'
              />
              <MDBCardBody><br />
                <MDBCardTitle style={{ fontSize: '16px' }}>Ankhmaa Byambaa</MDBCardTitle><br />
                <MDBCardText style={{ fontSize: '13px' }}>
                  Research Officer
                </MDBCardText>
                <MDBCardText style={{ fontSize: '13px' }}>
                  PhD student
                </MDBCardText>
              </MDBCardBody>
              <MDBCardFooter id='connect'>
                <a href="https://twitter.com/AnxmaaB" target="_blank" rel="noreferrer">
                  <TwitterIcon style={{ color: 'rgb(49, 168, 232)' }} />
                </a>
              </MDBCardFooter>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard className='h-100'>
              <MDBCardImage style={{ objectFit: 'cover' }}
                src={karhauimage}
                alt='Kar-Hau (John) Chong'
                position='top'
              />
              <MDBCardBody><br />
                <MDBCardTitle style={{ fontSize: '16px' }}>Dr. Kar Hau Chong</MDBCardTitle><br />
                <MDBCardText style={{ fontSize: '13px' }}>
                  Advisor
                </MDBCardText>
              </MDBCardBody>
              <MDBCardFooter id='connect'>
                <a href="https://twitter.com/DrJohnChong" target="_blank" rel="noreferrer">
                  <TwitterIcon style={{ color: 'rgb(49, 168, 232)' }} />
                </a>
              </MDBCardFooter>
            </MDBCard>
          </MDBCol>
          {/* </MDBRow> */}
        </div>
      </div>
    </div>
    </div>
  );
}

export default Team;
